import React from 'react';
import { AdditionalInfoHeroSectionProps } from '../../../../../Sections/AdditionalInfo/HeroSection/HeroSection';
import * as classes from './HeroSection.module.scss';
import Container from '../../../../../Common/Container/Container';
import cn from 'classnames';
import AdditionalInfoCard from '../../../Components/AdditionalInfoCard/AdditionalInfoCard';
import educationIcon from '../../../../../../assets/icons/education.svg';
import awardsIcon from '../../../../../../assets/icons/awards.svg';
import profIcon from '../../../../../../assets/icons/proff.svg';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import circleImg from '../../../../../../assets/images/circle-left-azure.svg';
import TriangleBlock from '../../../Components/TriangleBlock/TriangleBlock';

const HeroSection = ({ education, awards, profAssociations }: AdditionalInfoHeroSectionProps) => {
  const { t } = useTranslation();

  const educationRender = (
    <div className={cn(classes.cardWrapper, 'col-md-12 col-lg-4')}>
      <AdditionalInfoCard icon={educationIcon} title={t('additionalInfo.heroSection.education')}>
        <ul className={classes.educationList}>
          {education?.map((item, index) => (
            <li key={index}>
              <div className={classes.title}>{item.certificateName}</div>
              <div className={classes.deliveredBy}>{item.deliveredBy}</div>
              <div className={classes.year}>{item.yearObtained}</div>
            </li>
          ))}
        </ul>
      </AdditionalInfoCard>
    </div>
  );
  const awardsRender = (
    <div className={cn(classes.cardWrapper, 'col-md-12 col-lg-4')}>
      <AdditionalInfoCard icon={awardsIcon} title={t('additionalInfo.heroSection.awards')}>
        <ul className={classes.simpleList}>
          {awards?.map((item, index) => (
            <li key={index}>{item.description}</li>
          ))}
        </ul>
      </AdditionalInfoCard>
    </div>
  );
  const profAssociationsRender = (
    <div className={cn(classes.cardWrapper, 'col-md-12 col-lg-4')}>
      <AdditionalInfoCard icon={profIcon} title={t('additionalInfo.heroSection.profAssociations')}>
        <ul className={classes.simpleList}>
          {profAssociations?.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </AdditionalInfoCard>
    </div>
  );

  return (
    <section className={classes.wrapper} data-aos='fade-in'>
      <img src={circleImg} alt='' className={classes.circleDecorator} />
      <TriangleBlock className={classes.bigTriangle} />
      <TriangleBlock className={classes.smallTriangle} />
      <div className={classes.roundedSquareDecorator} />
      <Container>
        <div className={'row'}>
          {education?.length && educationRender}
          {awards?.length && awardsRender}
          {profAssociations?.length && profAssociationsRender}
        </div>
      </Container>
    </section>
  );
};

export default HeroSection;
